<!-- eslint-disable max-len -->
<style scoped>
 .incentive-payments-dialog-yes {
    background-color: #3F6E75;
  }
  .incentive-payments-dialog-no {
    background-color: #863A21;
  }
  .read-only-row {
    padding-bottom: 10px;
  }
</style>
<template>
  <div class="view-contents">
    <UnavailablePageModal
      v-if="project"
      pageName="Incentive Payments"
      :project="project"
      :projectId="project.id"
    />
    <div class="section-header">
      <div class="row">
        <b-col cols='6' class='bold-title'>Incentive Payments</b-col>
        <b-col cols='6' class='text-right'>
          <b-link v-if='isEditable' class="add-link" @click="onOpenProjectIncentivePaymentModalAddClick">
            <b-icon icon="plus"></b-icon>
            <span>Add Incentive</span>
          </b-link>
          <!-- <span v-else class='missing-control-label'>(No Incentives available for '{{this.project.category}}' Projects)</span> -->
        </b-col>
      </div>
    </div>
    <div class="section-header">
      <b-overlay :show="formLoading">
        <div class='row'>
          <div class='col'>
            <b-modal id="projectIncentivePaymentModalAdd" title="New Incentive Payment" size="xl">
              <p>
                <VueFormGenerator :schema="formSchemaAdd"
                  :model="projectIncentivePayment"
                  :options="formOptions"
                  @validated="onValidatedAdd"
                  @model-updated='onProjectIncentivePaymentModelUpdated'/>
              </p>
              <template v-slot:modal-footer>
                <b-button size="sm" variant="danger" @click="onProjectIncentivePaymentAddCancelClick" class='incentive-payments-dialog-no'>Cancel</b-button>
                <b-button :disabled="!formValidAdd" size="sm" variant="success" @click="onProjectIncentivePaymentAddClick" class='incentive-payments-dialog-yes'>
                  <span>Save Payment</span>
                </b-button>
              </template>
            </b-modal>
            <b-modal id="projectIncentivePaymentModalUpdate" v-bind:title="'Edit Incentive Payment'" size="xl">
              <div>
                <b-overlay opacity=".33">
                  <VueFormGenerator :schema="formSchemaUpdate"
                    :model="projectIncentivePayment"
                    :options="formOptions"
                    @validated="onValidatedUpdate"
                    @model-updated='onProjectIncentivePaymentModelUpdated'/>
                  <template v-slot:overlay>
                    <div></div>
                  </template>
                </b-overlay>
              </div>
              <template v-slot:modal-footer>
                <b-button size="sm" variant="danger" @click="onProjectIncentivePaymentUpdateCancelClick" class='incentive-payments-dialog-no'>Cancel</b-button>
                <b-button :disabled="!formValidUpdate" size="sm" variant="success" @click="onProjectIncentivePaymentUpdateClick" class='incentive-payments-dialog-yes'>
                  <span>Save Payment</span>
                </b-button>
              </template>
            </b-modal>
          </div>
        </div>
        <div class='row'>
          <div class='col'>
            <div v-if="projectIncentivePayments.length === 0">No incentive payments have been added</div>
            <div v-if="projectIncentivePayments.length > 0 && projectFundingSources.length > 0 && projectIncentiveTypes.length > 0">
              <b-table id='incentivePaymentTable' striped :fields="projectIncentivePaymentsFields" :items="getProjectIncentivePayments()">
                <template v-slot:cell(payee)="row">
                  {{ getSelectedPayee(row.item) }}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-link @click="onProjectIncentivePaymentEditClick(row)" class="mr-1">
                    <span>Edit</span>
                  </b-link>
                  <span v-if='isEditable || isAdmin()'>
                    <span>|&nbsp;</span>
                    <span v-b-modal="'deleteProjectIncentivePaymentModal'" v-on:click="setDeleteProjectIncentivePayment(row)">
                      <a href="#">Delete</a>
                    </span>
                  </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <b-modal id="deleteProjectIncentivePaymentModal" title="Confirm Incentive Payment Delete" @ok="onProjectIncentivePaymentDeleteOkClick()">
          <div>Are you sure you want to delete this Incentive Payment?</div>
          <div>and all of its associated information?</div>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
            <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
          </template>
        </b-modal>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks */
import { mapState } from 'vuex';
import UnavailablePageModal from '@/components/common/UnavailablePageModal.vue';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import ProjectSchemaHelper from '../../mixins/projectSchemaHelper';

export default {
  name: 'ProjectIncentives',
  mixins: [ProjectApprovalMembershipManager, ProjectSchemaHelper],
  components: {
    UnavailablePageModal,
  },
  computed: {
    ...mapState(['config']),
    ...mapState('User', {
      insightlyUser: (state) => state.insightlyUser,
    }),
    ...mapState('Project', {
      project: (state) => state.project,
      projectIncentivePayments: (state) => state.projectIncentivePayments,
      fundingSources: (state) => state.fundingSources,
      incentiveTypes: (state) => state.incentiveTypes,
    }),
    ...mapState('Contact', {
      contactBriefs: (state) => state.contactBriefs,
    }),
    ...mapState('Organization', {
      organizationBriefs: (state) => state.organizationBriefs,
    }),
    projectIncentiveTypes() {
      if (!this.project) {
        return [];
      }

      return this.sortLookupArray(this.incentiveTypes.filter((e) => e.categories.includes(this.project.category)));
    },
  },
  data() {
    return {
      formLoading: false,
      formOptions: { validateAfterChanged: true },
      formSchemaAdd: {},
      formSchemaUpdate: {},
      formValidAdd: false,
      formValidUpdate: false,
      projectId: null,
      projectIncentivePayment: null,
      projectIncentivePaymentModalAddId: 'projectIncentivePaymentModalAdd',
      projectIncentivePaymentModalUpdateId: 'projectIncentivePaymentModalUpdate',
      projectIncentivePaymentsFields: [
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'payee',
          label: 'Payee',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'fundingSource',
          label: 'Funding Source',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'frequency',
          label: 'Frequency',
          formatter: (value) => {
            if (value) {
              return value;
            }
            return '';
          },
        },
        {
          key: 'amountPaid',
          label: 'Amount',
          formatter: (value) => {
            if (value) {
              return this.$options.filters.toCurrency(value);
            }
            return '';
          },
          class: 'text-right',
        },
        {
          key: 'dateDue',
          label: 'Due Date',
          formatter: (value) => {
            if (value && (new Date(value) instanceof Date)) {
              return (new Date(value)).toLocaleDateString();
            }
            return value;
          },
        },
        {
          key: 'datePaid',
          label: 'Date Paid',
          formatter: (value) => {
            if (value && (new Date(value) instanceof Date)) {
              return (new Date(value)).toLocaleDateString();
            }
            return value;
          },
        },
        {
          key: 'notes',
          label: 'Notes',
          formatter: (value) => value,
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      projectIncentivesLoading: false,
      projectIncentivesSaving: false,
      projectFundingSources: [],
      payees: [],
      payeesOrgs: [],
      vendorTypes: ['Individual Contact', 'Organization'],
      vendorType: 'Individual Contact',
    };
  },
  mounted() {
    this.projectId = parseInt(this.$route.params.id, 10);
    (async () => {
      await this.load();
    })();
  },
  methods: {
    getProjectIncentivePayments() {

      let projectIncentivePayments = this.projectIncentivePayments.map((e) => ({
        id: e.id,
        projectId: this.projectId,
        incentiveTypeId: e.incentiveTypeId,
        incentiveType: this.projectIncentiveTypes.filter((x) => x.id === e.incentiveTypeId)[0],
        frequency: this.projectIncentiveTypes.filter((x) => x.id === e.incentiveTypeId)[0].frequency,
        fundingSourceId: e.fundingSourceId,
        fundingSource: this.projectFundingSources.filter((x) => x.id === e.fundingSourceId)[0],
        amountPaid: e.amountPaid,
        dateDue: e.dateDue,
        datePaid: e.datePaid,
        notes: e.notes,
        payee: this.getPayee(e),
        payeeId: this.getPayeeId(e),
        payeeOrg: this.getPayeeOrg(e),
        payeeOrgId: this.getPayeeOrgId(e),
        vendorType: e.vendorType,
      }));

      projectIncentivePayments = projectIncentivePayments.sort((a, b) => {
        if (a.dateDue < b.dateDue) return -1;
        if (a.dateDue === b.dateDue) return 0;
        return 1;
      });

      return projectIncentivePayments;
    },
    initProjectIncentivePayment() {
      return {
        projectId: this.projectId,
        incentiveTypeId: null,
        incentiveType: null,
        dateDue: this.project.startDate ? new Date(this.project.startDate) : new Date(),
        notes: null,
        payeeId: null,
        payeeOrgId: null,
        vendorType: 'Individual Contact',
      };
    },
    async load() {
      this.formLoading = true;

      await this.$store.dispatch('Project/getIncentiveTypes');
      await this.$store.dispatch('Project/fetchFundingSources');
      await this.$store.dispatch('Project/getProject', this.projectId);
      await this.$store.dispatch('Contact/getContactBriefs');
      await this.$store.dispatch('Organization/getOrganizationBriefs');

      this.payees = this.contactBriefs;
      this.payeesOrgs = this.organizationBriefs;

      const projectFundingSources = this.fundingSources.map((e) => {
        const qbAccount = e.customfields.filter((customfield) => customfield.fielD_NAME === 'Account__c')[0];
        const projectFundingSource = {
          id: e.recorD_ID,
          name: e.recorD_NAME,
          source: qbAccount.fielD_VALUE,
        };
        return projectFundingSource;
      });

      this.projectFundingSources = this.sortLookupArray(
        projectFundingSources.filter((e) => e.source?.split(':')?.[1] === 'Landowner Payments'),
      );

      await this.$store.dispatch('Project/getProjectIncentivePayments', this.projectId);

      this.formSchemaAdd = this.getIncentivePaymentSchemaAdd();
      this.formSchemaUpdate = this.getIncentivePaymentSchemaUpdate();

      this.formLoading = false;
    },
    getSelectedPayee(e) {
      if (e.vendorType === 'Individual Contact') {
        return e?.payee?.name ?? 'N/A';
      }
      return e?.payeeOrg?.name ?? 'N/A';
    },
    getPayee(e) {
      if (e.vendorType === 'Individual Contact') {
        return this.payees.filter((x) => x.id === e.payeeId)[0];
      }
      return '';
    },
    getPayeeId(e) {
      if (e.vendorType === 'Individual Contact') {
        return e.payeeId;
      }
      return 0;
    },
    getPayeeOrg(e) {
      if (e.vendorType === 'Individual Contact') {
        return '';
      }
      return this.payeesOrgs.filter((x) => x.id === e.payeeOrgId)[0];
    },
    getPayeeOrgId(e) {
      if (e.vendorType === 'Individual Contact') {
        return 0;
      }
      return e.payeeOrgId;
    },
    onOpenProjectIncentivePaymentModalAddClick() {
      this.projectIncentivePayment = this.initProjectIncentivePayment();
      this.validateRequiredFieldsAdd();
      this.$bvModal.show(this.projectIncentivePaymentModalAddId);
    },
    onProjectIncentivePaymentAddClick() {
      (async () => {
        this.formLoading = true;
        this.$bvModal.hide(this.projectIncentivePaymentModalAddId);
        await this.$store.dispatch('Project/postProjectIncentivePayment', this.projectIncentivePayment);
        await this.$store.dispatch('Project/getProjectIncentivePayments', this.projectId);
        this.projectIncentivePayment = this.initProjectIncentivePayment();
        this.formLoading = false;
      })();
    },
    onProjectIncentivePaymentAddCancelClick() {
      this.$bvModal.hide(this.projectIncentivePaymentModalAddId);
      this.projectIncentivePayment = this.initProjectIncentivePayment();
    },
    onProjectIncentivePaymentDeleteOkClick() {
      this.onProjectIncentivePaymentDeleteClick(this.deleteProjectIncentivePayment);
    },
    onProjectIncentivePaymentDeleteClick(item) {
      (async () => {
        this.formLoading = true;
        await this.$store.dispatch('Project/deleteProjectIncentivePayment', item.id);
        await this.$store.dispatch('Project/getProjectIncentivePayments', this.projectId);
        this.projectIncentivePayment = this.initProjectIncentivePayment();
        this.formLoading = false;
      })();
    },
    onProjectIncentivePaymentEditClick(row) {
      this.projectIncentivePayment = { ...row.item };
      this.validateRequiredFieldsUpdate([]);
      this.$bvModal.show(this.projectIncentivePaymentModalUpdateId);
    },
    onProjectIncentivePaymentUpdateClick() {
      (async () => {
        this.formLoading = true;
        this.$bvModal.hide(this.projectIncentivePaymentModalUpdateId);
        this.projectIncentivePayment.dateDue = new Date(this.projectIncentivePayment.dateDue);
        this.projectIncentivePayment.datePaid = this.projectIncentivePayment.datePaid ? new Date(this.projectIncentivePayment.datePaid) : null;

        const [selectedProjectIncentiveTypes] = this.projectIncentiveTypes.filter((x) => x.id === this.projectIncentivePayment.incentiveTypeId);
        this.projectIncentivePayment.incentiveType = selectedProjectIncentiveTypes;

        await this.$store.dispatch('Project/putProjectIncentivePayment', this.projectIncentivePayment);
        await this.$store.dispatch('Project/getProjectIncentivePayments', this.projectId);
        this.projectIncentivePayment = this.initProjectIncentivePayment();
        this.formLoading = false;
      })();
    },
    onProjectIncentivePaymentUpdateCancelClick() {
      this.$bvModal.hide(this.projectIncentivePaymentModalUpdateId);
      this.projectIncentivePayment = this.initProjectIncentivePayment();
    },
    onValidatedAdd(isValid, errors) {
      this.formValidAdd = isValid;
      this.validateRequiredFieldsAdd(errors || []);
    },
    onValidatedUpdate(isValid, errors) {
      this.formValidUpdate = isValid;
      this.validateRequiredFieldsUpdate(errors || []);
    },
    isAdmin() {
      return this.insightlyUser.administrator;
    },
    setDeleteProjectIncentivePayment(row) {
      this.deleteProjectIncentivePayment = row.item;
    },
    sortLookupArray(lookupArray) {
      return lookupArray.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name === b.name) return 0;
        return 1;
      });
    },
    validateRequiredFieldsAdd(errors) {
      this.formValidAdd = true;
      if (!this.projectIncentivePayment.incentiveTypeId) this.formValidAdd = false;
      this.validatePayee();
      if (!this.projectIncentivePayment.vendorType) this.formValidAdd = false;
      if (!this.projectIncentivePayment.fundingSourceId) this.formValidAdd = false;
      if (!this.projectIncentivePayment.dateDue) this.formValidAdd = false;
      if (!this.projectIncentivePayment.amountPaid || this.projectIncentivePayment.amountPaid < 0) this.formValidAdd = false;
      if (errors && errors.length > 0) this.formValidAdd = false;
    },
    validatePayee() {
      if (this.projectIncentivePayment.payeeId && this.projectIncentivePayment.payeeId !== 0) return;
      if (this.projectIncentivePayment.payeeOrgId && this.projectIncentivePayment.payeeOrgId !== 0) return;
      this.formValidAdd = false;
    },
    validatePayeeOnUpdate() {
      if (this.projectIncentivePayment.payeeId && this.projectIncentivePayment.payeeId !== 0) return;
      if (this.projectIncentivePayment.payeeOrgId && this.projectIncentivePayment.payeeOrgId !== 0) return;
      this.formValidUpdate = false;
    },
    validateRequiredFieldsUpdate(errors) {
      this.formValidUpdate = true;
      this.validatePayeeOnUpdate();
      if (!this.projectIncentivePayment.vendorType) this.formValidUpdate = false;
      if (!this.projectIncentivePayment.fundingSourceId) this.formValidUpdate = false;
      if (errors && errors.length > 0) this.formValidUpdate = false;
    },
    async onProjectIncentivePaymentModelUpdated(fieldValue, fieldName) {
      if (fieldName === 'vendorType') {
        if (this.projectIncentivePayment.vendorType && this.projectIncentivePayment.vendorType === 'Organization') this.projectIncentivePayment.payeeId = 0;
        if (this.projectIncentivePayment.vendorType && this.projectIncentivePayment.vendorType === 'Individual Contact') this.projectIncentivePayment.payeeOrgId = 0;
      }
    },
  },
};
</script>
